import { LAUNCH_TYPES } from './constants';

// Helper function to format address from address object
export const formatAddressFromObject = addressObject => {
  if (!addressObject) return '';

  const addressParts = [];
  const { home, street, city, region, postal_code } = addressObject;

  // Handle street address part
  if (home && street) {
    addressParts.push(`${home} ${street}`);
  } else {
    addressParts.push(home || street);
  }

  // Add remaining address components
  if (city) addressParts.push(city);
  if (region) addressParts.push(region);
  if (postal_code) addressParts.push(postal_code);

  return addressParts.join(', ');
};

// Helper function to get value from react-select option
export const getSelectValue = option => option?.value || option || '';

// Helper to check if coordinates are valid
export const isValidCoordinates = (latitude, longitude) =>
  latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180;

// Helper to check if the launch type is test or standby
export const checkLaunchType = (launchType = null) => {
  if (!launchType) return null;
  const lowerCaseType = launchType.toLowerCase();
  if (
    lowerCaseType === LAUNCH_TYPES.TEST.toLowerCase() ||
    lowerCaseType === LAUNCH_TYPES.STANDBY.toLowerCase()
  ) {
    return launchType;
  }
  return false;
};
